import { render, staticRenderFns } from "./think.vue?vue&type=template&id=4f86a276&scoped=true&"
import script from "./think.vue?vue&type=script&lang=js&"
export * from "./think.vue?vue&type=script&lang=js&"
import style0 from "./think.vue?vue&type=style&index=0&id=4f86a276&scoped=true&lang=less&"
import style1 from "./think.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f86a276",
  null
  
)

export default component.exports